module.exports = __webpack_public_path__ + "img/downarrow.aae920ab.svg";